import CallToPage from "../CallToPage/CallToPage";
import DefineListWithoutFormik from "../DefineList/DefineListWithoutFormik";

const top100Films = [
  { title: "3 وعده ناهار", ServicesId: "0816793B7F654415BC8D971C53D9CD03" },
  { title: "اقامت در هتل", ServicesId: "09CCF898737A491C99E56886034BE167" },
  {
    title: "بیمه مسافرتی به همراه سیم کارت",
    value: "0A00134A2BD846A0BB013323A218D22E",
  },
  { title: "ناهار", ServicesId: "11CCC1433BCE4103990141C65449A856" },
  { title: "کمیسیون", ServicesId: "13E7F9D4B57649F88A60B2DF888F1B34" },
  { title: "وسیله نقلیه محلی", ServicesId: "1459A2003AF441869F282135F7389B00" },
  {
    title: "3 وعده ناهار منو باز",
    ServicesId: "1645A69CC6294106B41DDFD2B1D86A7C",
  },
  {
    title: "سافاری ( هزینه به عهده مسافر )",
    value: "174CADC7A0DE4DBA986E5BA62CCC29F3",
  },
  { title: "صبحانه + عصرانه", ServicesId: "1AF5F353752748FBB5A173D4E5F80793" },
  {
    title: "3 وعده صبحانه منو باز",
    ServicesId: "1C92B6DE420949FE9221F01D24577B0A",
  },
  {
    title: "3 وعده صبحانه بوفه",
    ServicesId: "20EF5D21AB814AD388AA3833AE1E52DA",
  },
  {
    title: "مجوز ورود به منطقه حفاظت شده حیات وحش",
    ServicesId: "297CBA3B8D544419994E3FE24470AA9B",
  },
  { title: "مجوز عکاسی", ServicesId: "2B5148AA240542A086FD19D3324611BF" },
  {
    title: "بلیط شناور دریایی (رفت و برگشت)",
    ServicesId: "305099CD8F1D4882B09A11F97BFD8296",
  },
  {
    title: "4 شب و 5 روز اقامت در هتل به همراه صبحانه",
    ServicesId: "3AABB9A91A1D427BA9206BEA0B5E8CFA",
  },
  {
    title: "گشت شهری با ناهار",
    ServicesId: "3F360C476E364DF18C22DF66C7D0FE93",
  },
  {
    title: "1 وعده صبحانه منو باز",
    ServicesId: "4938795FC0C547B086B16231DDFA4F38",
  },
  { title: "تست PCR", ServicesId: "4AA0ECFC2D534318B3CA1F9DBDC17FAC" },
  {
    title: "رفت و برگشت با اتوبوس 25 نفره VIP  تخت شو",
    ServicesId: "4AF1986A29C54C95A42656DC53725601",
  },
  { title: "استقبال فرودگاهی", ServicesId: "4B0199FB489F4FB6A3CDF2D4181B2382" },
  {
    title: "1 شب اقامت در اقامتگاه بوم‌گردی",
    ServicesId: "4B1BBCB6046A40CEB94781F34A8FE482",
  },
  { title: "همراهی محیطبان", ServicesId: "4D9583D2C4AC467AA77B790EA44860D3" },
  { title: "آب معدنی", ServicesId: "5384AB00F9864133900AC17A6F5DEEFE" },
  { title: "ارزش افزوده", ServicesId: "5658F0577F1D40FA828362E89F8F3475" },
  { title: "کمپ کویری", ServicesId: "56CC27551EB24A578C92FE101EA0177F" },
  { title: "شناور دریایی", ServicesId: "581038D7C06C49EF8E657FD73EA25AF4" },
  {
    title: "رفت و برگشت اتوبوس VIP",
    ServicesId: "5FE2EC7B268A40739E432E6A80340E9B",
  },
  {
    title: "امکان خرید اقساطی",
    ServicesId: "608A536872C44660AE1F44CE65938CC1",
  },
  {
    title: "1 وعده ناهار منو باز",
    ServicesId: "6638DCDAA85C44E795F0452C8AD67BE8",
  },
  { title: "گشت شهری", ServicesId: "6D7C8D64227B4B1586CE1E4AC4B715F4" },
  { title: "سیمکارت", ServicesId: "7145CFA6ED1B4844899D9986548695B1" },
  {
    title: "زیارت دوره‌ای نجف، کربلا، سامرا و کاظمین",
    ServicesId: "71FA623218204F46A3FCFA350B05C2AB",
  },
  {
    title: "بلیط قایق سواری هنگام",
    ServicesId: "74E7A186FA404DB0A1CFCB42A22D7FC7",
  },
  { title: "مدیر مداح", ServicesId: "752424C248B945C5BE2024DE10BA7C28" },
  { title: "عصرانه", ServicesId: "8252967C7EAA409C95AEE2AF5817AFEC" },
  { title: "قایق", ServicesId: "8272FA14FE384DCAB374BB48E87099FD" },
  { title: "ترانسفر", ServicesId: "837C7E7DA7B8487DAACAEDA2CB28B08E" },
  {
    title: "عکاسی حرفه ای + چاپ عکس رایگان",
    ServicesId: "8993FA166DED4C04A3FDBD0D1910FE6C",
  },
  {
    title: "لیدر دارای کارت گردشگری",
    ServicesId: "8AE0F22EB6C24B3FB20AC8D4EBEF9D69",
  },
  { title: "نیم شارژ هتل", ServicesId: "8C1F7F332B3D4275A2C27EA77AF635F9" },
  {
    title: "سیم‌کارت به ازای هر اتاق",
    ServicesId: "931D866215FC4A4EBE36741689205281",
  },
  { title: "بلیط رفت و برگشت", ServicesId: "95DDE2878FE44F519CFDFA9DF5118CFD" },
  {
    title: "رفت و برگشت با اتوبوس توریستی",
    ServicesId: "962A0CDF7A3E4B3B96B10F9AF585817C",
  },
  {
    title: "2 وعده صبحانه بوفه",
    ServicesId: "9D5E59DE0A834F6D847F5F884FCC5F6B",
  },
  { title: "رصد ستارگان", ServicesId: "9EA9322A44A74FBEBF664BA35262AD39" },
  {
    title: "تورلیدر (راهنما) فارسی زبان",
    ServicesId: "9F7F55CC81174357816597B187650D05",
  },
  { title: "گشت آپشنال", ServicesId: "A09EAE5C86EA4B28BE1A7EE05FF76771" },
  { title: "ورودیه‌ها", ServicesId: "A32A4D5A391942CB8059BC4A6CD79388" },
  {
    title: "1 شب اقامت هتل 4 ستاره",
    ServicesId: "A394D765C2084DAC8E0AE56FCA9DF985",
  },
  {
    title: "شتر سواری ( هزینه به عهده مسافر )",
    ServicesId: "A5B4D1D57E2B41068B29374E0E7DF524",
  },
  {
    title: "امکان تهیه غذا از اقامتگاه",
    ServicesId: "A791E5246C634278BC43D281F79ACCFB",
  },
  { title: "بیمه سامان", ServicesId: "A8A7468F6AFB433FB78FE7CB8F31043D" },
  { title: "شب نشینی دور آتش", ServicesId: "A928952009D04AD99E31D8190FC5C4FC" },
  {
    title: "تور لیدر دارای کارت گردشگری",
    ServicesId: "ABF632F37DA446838C51866799BB7729",
  },
  { title: "ون توریستی", ServicesId: "AD12C415431244BC90CB16EA51C2D178" },
  {
    title: "جشن شب سال نو ( هزینه به عهده مسافر)",
    ServicesId: "AF1DA0C0B9F048F6AD74F3149863838C",
  },
  { title: "تور ماسال", ServicesId: "AF3BFBCCCFBB4BE48FE5988BA0CEE5BF" },
  {
    title: "اجرای بازی‌های گروهی",
    ServicesId: "B19F23F4D54042C09C04FEC91CD44BCA",
  },
  { title: "کویر گردی", ServicesId: "B2EDC93E9B184DEB909C947BBE1B2702" },
  { title: "استخر", ServicesId: "B99555FB7D8742A887E741D3F15FC371" },
  {
    title: "1 شب اقامت در خانه روستایی",
    ServicesId: "BF000D503A3A4032A261255A451C5BD5",
  },
  { title: "خدمات هتل", ServicesId: "BF9B38B889584E06BF92A8B4CAC44181" },
  {
    title: "اقامت به همراه صبحانه",
    ServicesId: "C071C48A3AE140AE82677DD68F7734DF",
  },
  { title: "بلیط کنسرت", ServicesId: "C33C2FD346774B9C85A66AD15DDAA8AB" },
  {
    title: "1 وعده صبحانه بوفه",
    ServicesId: "C5633B147C734FDDA589E1E302D4D6B7",
  },
  {
    title: "1شب اقامت در هتل 4 ستاره ",
    ServicesId: "C6FD5DE73DCC489CA40572932D587F9B",
  },
  {
    title: "بلیط رفت و برگشت قطار",
    ServicesId: "C759D65A75574FD1B0370709E9C1C647",
  },
  { title: "ویزا", ServicesId: "CCA9EC60306942DFAE86F2DA904184EE" },
  { title: "بیمه پاسارگاد", ServicesId: "CD3510FDC4534FF1BA96DDB68BADE213" },
  {
    title: "موتور سواری ATV ( هزینه به عهده مسافر )",
    ServicesId: "CD3A99B1963A4CF6886CFD888608EF8C",
  },
  { title: "گشت کامل مناطق", ServicesId: "CD864A1BDE26428C97DD77AA0CEF1DE7" },
  { title: "پرواز محلی", ServicesId: "D74F1F83CCBB456A9F5D2C246248A9CA" },
  {
    title: "وسیله نقلیه توریستی",
    ServicesId: "D86358217A4A4281A44A3BB04B0AE645",
  },
  {
    title: "راهنمای تخصصی پرندگان و حیات وحش",
    ServicesId: "DEB87EEDCA0C46AA824C0D49710AD354",
  },
  { title: "راهنمای محلی", ServicesId: "E032B81543844D6B8F32F28097BA2A9D" },
  {
    title: "2 وعده ناهار منو باز",
    ServicesId: "E1A1B8996A604107ABBEAF2D8AC3BC3D",
  },
  { title: "تور گیلانگردی", ServicesId: "E204F70AB72B40AE916B6041962DF398" },
  {
    title: "2 شب اقامت هتل 3 ستاره",
    ServicesId: "E453E22F2F194F9DB74C5287B108040D",
  },
  { title: "بیمه مسافرتی", ServicesId: "E4F07314D3134EF999075277C176163D" },
  {
    title: "وسیله حمل و نقل محلی (ون توریستی - شناور دریایی - قایق)",
    ServicesId: "E5E4803922A14424B77161555658929C",
  },
  { title: "1 وعده شام ", ServicesId: "EA043CA595994F66A0C322BBFD6EC341" },
  { title: "استخر سر پوشیده", ServicesId: "EC40DE9EA7644C5A931072D9F181DEDC" },
  {
    title: "تور لیدر فارسی و ارمنی زبان",
    ServicesId: "F56B8C8993A74BC1931AF79BB8DE21DE",
  },
  { title: "صبحانه", ServicesId: "F93A889B96DC4D8C9FBB5860AB5A2371" },
  { title: "تغییر تاریخ", ServicesId: "F9F8E0857D21465E93DF53BF7EC8547F" },
  { title: "حمام ترکی", ServicesId: "FA2FD91E0C5A48919CB6EC057C6AB00E" },
  {
    title: "صبحانه منو باز (بوفه) + ناهار و شام (2 نوع)",
    ServicesId: "FD86756CC5FE4F4AA3F134A89FF680D4",
  },
  {
    title: "ترانسفر راه آهن تا هتل",
    ServicesId: "FDAEFCEDEEFA4D07A534017281B0DA5C",
  },
];
const UpdateTourFormFourthStep = ({
  servicesList,
  deleteServiceListHandler,
  ChangeSubmitTracker,
  prevStepTab,
  loading,
}) => {
  const goPrevStep = () => {
    prevStepTab();
  };
  return (
    <>
      <div className="flex w-full md:w-1/3 px-3">
        <DefineListWithoutFormik
          name="requierdTools"
          label="شامل می‌باشد"
          list={servicesList}
          suggested={top100Films}
          deleteServiceListHandler={deleteServiceListHandler}
          ChangeSubmitTracker={ChangeSubmitTracker}
        />
      </div>
      {loading && <p>در حال بارگزاری ...</p>}
      <div className="w-full flex justify-between mx-4 md:mx-0">
        <div className="flex w-1/2 mt-2 gap-2 px-3">
          <div className="flex mt-2">
            <CallToPage
              address="tourlist"
              text="انصراف"
              bGColor="bg-red-600"
              hoverBgColor="bg-red-700"
            />
          </div>
          <button
            onClick={goPrevStep}
            className="block w-auto mt-2 disabled:bg-slate-400 disabled:text-white disabled:cursor-not-allowed bg-red-400 text-white text-center rounded-md py-2 px-4"
          >
            مرحله قبل
          </button>
        </div>
        <div className="flex justify-end w-1/2 mt-2 gap-2 px-3">
          <div className="flex mt-2 ">
            <CallToPage
              address="tourlist"
              text="پایان تغییرات"
              bGColor="bg-lightGreenKite"
              hoverBgColor="bg-darkGreenKite"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateTourFormFourthStep;
